import React, { useTransition } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import EpisodePage from '../pages/EpisodePage';

// Helper component for Episode Route to handle ID lookup
// Defined outside App to prevent re-mounting on re-renders
const EpisodeRoute = ({ scheduledLeads, leads, setLeads, user, db, settings, setSelectedLead }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isPending, startTransition] = useTransition();

    const episode = scheduledLeads.find(ep => ep.id === id);
    // If not found, redirect to hub
    if (!episode && leads.length > 0) return <Navigate to="/episodes" replace />;
    if (!episode) return <div className="p-8 text-center text-gray-500">Loading episode...</div>;

    const handleEpisodeStatusUpdate = async (newStatus) => {
        setLeads(prevLeads =>
            prevLeads.map(lead =>
                lead.id === episode.id ? { ...lead, productionStatus: newStatus } : lead
            )
        );
        if (user && db) {
            try {
                const leadRef = doc(db, `tenants/${user.uid}/contacts`, episode.id);
                await updateDoc(leadRef, { productionStatus: newStatus, lastUpdated: new Date().toISOString() });
            } catch (error) {
                console.error("Error updating episode status:", error);
            }
        }
    };

    const handleViewLead = () => {
        setSelectedLead(episode);
        startTransition(() => {
            navigate('/guests');
        });
    };

    return <EpisodePage
        episode={episode}
        onBack={() => startTransition(() => navigate('/episodes'))}
        onEpisodeStatusUpdate={handleEpisodeStatusUpdate}
        onViewLead={handleViewLead}
        user={user}
        db={db}
        settings={settings}
    />;
};

export default EpisodeRoute;
